module.exports = __webpack_public_path__ + "img/icon-64.913399d9.png";